export class VAxis {
    title?: string;
    minValue?: string;
    maxValue?: string;
}